import React, {Component} from 'react';
import WxApi from '../../common/wxapi';
class WriterPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: ('ontouchstart' in window) ? ['touchstart', 'touchmove', 'touchend'] : ['mousedown', 'mousemove', 'mouseup'],
            cxt: null
        }
    };
    componentDidMount() {
        this.resizeCanvas();
        // Wait for the viewport to settle before recalculating the rotated canvas.
        this.handleResize = () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.resizeCanvas(true), 150);
        };
        window.addEventListener('resize', this.handleResize);
        this.is_drawed = false;
        if(WxApi.isMobile()){ //手机上面绘制签名            
            this.canvas.addEventListener("touchstart", function (e) { //开始绘制
                e.preventDefault();
                this.cxt.beginPath();
                const evt = e.touches[0];
                const point = this.getCanvasPoint(evt.clientX, evt.clientY);
                this.cxt.moveTo(point.x, point.y);
            }.bind(this), false);
           
            this.canvas.addEventListener("touchmove", function (e) { //绘制中
                e.preventDefault();
                const evt = e.touches[0];
                const point = this.getCanvasPoint(evt.clientX, evt.clientY);
                this.is_drawed = true
                this.cxt.lineTo(point.x, point.y);
                this.cxt.stroke();
            }.bind(this), false);
            
            this.canvas.addEventListener("touchend", function (e) { //结束绘制
                e.preventDefault();
                this.cxt.closePath();
            }.bind(this), false);

        }else{ //电脑浏览器上绘制签名
           
            let begainPaint = false           
            this.canvas.addEventListener("mousedown", function (e) { //开始绘制
                begainPaint = true          
                e.preventDefault();
                this.cxt.beginPath();
                const evt = e;           
                const point = this.getCanvasPoint(evt.clientX, evt.clientY);
                this.cxt.moveTo(point.x, point.y)
            }.bind(this), false);
           
            this.canvas.addEventListener("mousemove", function (e) { //绘制中          
                e.preventDefault();
                if(begainPaint){
                    const evt = e;               
                    const point = this.getCanvasPoint(evt.clientX, evt.clientY);
                    this.cxt.lineTo(point.x, point.y)
                    this.cxt.stroke();
                    this.is_drawed = true;
                }           
            }.bind(this), false);
            
            this.canvas.addEventListener("mouseup", function (e) { //结束绘制       
                e.preventDefault();
                this.cxt.closePath();
                begainPaint = false;
            }.bind(this), false);
        }
    };
    componentWillUnmount() {
        clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.handleResize);
    }
    getCanvasPoint(clientX, clientY) {
        const coverPos = this.canvas.getBoundingClientRect();
        // Canvas may be stretched by CSS; map viewport coordinates back to its drawing buffer.
        return {
            x: (clientX - coverPos.left) * this.canvas.width / coverPos.width,
            y: (clientY - coverPos.top) * this.canvas.height / coverPos.height
        };
    }
    resizeCanvas(preserveDrawing) {
        const imageData = preserveDrawing && this.is_drawed ? this.canvas.toDataURL("image/png") : '';
        this.cxt = this.canvas.getContext("2d");
        const isLandscape = window.innerWidth > window.innerHeight;
        if(WxApi.isMobile() || isLandscape){
            // Landscape PC uses the full-width modal too; limit canvas height so action buttons remain visible.
            this.canvas.width = isLandscape ? window.innerWidth - 32 : Math.min(window.innerWidth, 450);
            this.canvas.height = isLandscape ? Math.min(Math.round(this.canvas.width * 0.32), window.innerHeight - 150) : Math.round(this.canvas.width * 0.5);
        }else{ //电脑浏览器的画布尺寸固定
            this.canvas.width = 450;
            this.canvas.height = 300;
        }
        this.cxt.strokeStyle = "#000";
        if(this.props.sign_bg_config && this.props.sign_bg_config.url){ //有背景图,则画布设置为透明
            this.cxt.fillStyle = 'rgba(255, 255, 255, 0)';
        }else{
            this.cxt.fillStyle = '#fff';
        }
        this.cxt.fillRect(0, 0, 99999, 99999);
        // A material signature is scaled down before merging, so retain a continuous stroke in the final image.
        this.cxt.lineWidth = this.props.sign_bg_config && this.props.sign_bg_config.url ? 2 : 1;
        this.cxt.lineCap = 'round'; // 线条末端添加圆形线帽，减少线条的生硬感
        this.cxt.lineJoin = 'round'; // 线条交汇时为原型边角
        // 利用阴影，消除锯齿
        this.cxt.shadowBlur = 1;
        this.cxt.shadowColor = '#000';
        if(imageData){
            const image = new Image();
            image.onload = () => this.cxt.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
            image.src = imageData;
        }
    }
    getImg() {      
        // Crop transparent canvas space so the material keeps more pixels for the actual signature strokes.
        return this.getCroppedImg();
    };
    getCroppedImg() {
        const padding = 10;
        const imageData = this.cxt.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const {data, width, height} = imageData;
        let minX = width;
        let minY = height;
        let maxX = -1;
        let maxY = -1;

        for(let y = 0; y < height; y++){
            for(let x = 0; x < width; x++){
                const index = (y * width + x) * 4;
                if(data[index + 3] && (data[index] < 245 || data[index + 1] < 245 || data[index + 2] < 245)){
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
        }

        if(maxX === -1){
            return this.canvas.toDataURL("image/png");
        }

        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(width - 1, maxX + padding);
        maxY = Math.min(height - 1, maxY + padding);

        const croppedCanvas = document.createElement('canvas');
        croppedCanvas.width = maxX - minX + 1;
        croppedCanvas.height = maxY - minY + 1;
        croppedCanvas.getContext('2d').drawImage(this.canvas, minX, minY, croppedCanvas.width, croppedCanvas.height, 0, 0, croppedCanvas.width, croppedCanvas.height);
        return croppedCanvas.toDataURL("image/png");
    };
    clearImg() {
        this.is_drawed = false;
        this.cxt.clearRect(0, 0, this.canvas.width, this.canvas.height);
    };
    render() {
        return (
            <div className="page">
                <canvas className="writer-canvas" ref={canvas => (this.canvas = canvas)} style={{backgroundColor: "#ffffff",cursor:"pointer"}}/>
            </div>
        );
    }
}

export default WriterPage;


